import { useEffect, useState } from "react";
// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Alert,
  Paper,
  Select,
  FormControl,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";

import { LIST_POST } from "../../config/const";
// jotai
import { useWindowSize } from "../../lib/useWindowSize";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface ChangeAccountCollaborateModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  changeAccount: 0 | 1;
  changeAccountID: number | null;
  setChangeAccount: (changeAccount: 0 | 1) => void;
  setChangeAccountID: (changeAccountID: number | null) => void;
  accountCollaborateCompanySaleList: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  title: string;
  getFormFunction: () => void;
  accountColumn: string;
}

export function ChangeAccountCollaborateModal(
  props: ChangeAccountCollaborateModalProps
) {
  const {
    onModal,
    swCloseModal,
    changeAccount,
    changeAccountID,
    setChangeAccount,
    setChangeAccountID,
    accountCollaborateCompanySaleList,
    title,
    getFormFunction,
    accountColumn,
  } = props;

  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [autocompleteInputList, setAutocompleteInputList] = useState<string[]>(
    []
  );
  const [autocompleteInput, setAutocompleteInput] = useState<string>("");

  useEffect(() => {
    let autocompleteInputList: string[] = [];
    autocompleteInputList = accountCollaborateCompanySaleList.map((input) => {
      return input.sale_company_name + " / " + input.account_name;
    });
    setAutocompleteInputList(autocompleteInputList);
  }, [accountCollaborateCompanySaleList]);

  useEffect(() => {
    let changeAccountID: number | null = null;
    if (changeAccount === 0) {
      changeAccountID = null;
      setAutocompleteInput("");
    } else {
      accountCollaborateCompanySaleList.map((input) => {
        if (
          autocompleteInput ===
          input.sale_company_name + " / " + input.account_name
        ) {
          changeAccountID = input.id;
        }
      });
    }
    setChangeAccountID(changeAccountID);
  }, [onModal, changeAccount, autocompleteInput]);

  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="cancelTitleBox"
          className="shippori-antique-regular"
        >
          {title}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          <Paper elevation={0}>
            <Box
              key="open1"
              sx={{
                maxHeight: windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                overflowY: windowWidth > 385 ? "auto" : undefined,
              }}
            >
              <Box className="serch-label">{accountColumn}の変更</Box>
              <Box key="servicePlanBox">
                <FormControl
                  fullWidth
                  sx={{
                    marginTop: "10px",
                    marginBottom: "20px",
                    marginLeft: "5px",
                    width: "calc(100% - 10px)",
                  }}
                >
                  <Select
                    labelId="serch-input-label"
                    id="serch-input-option"
                    key={"servicePlanSelect"}
                    sx={{
                      height: "30px",
                      textAlign: "end",
                      fontSize: "14px",
                    }}
                    value={changeAccount}
                    onChange={(e) => setChangeAccount(e.target.value as 0 | 1)}
                  >
                    <MenuItem
                      key={"follow_call_entry_status_conf"}
                      value={0}
                      sx={{
                        fontSize: "14px",
                        height: "24px",
                        minHeight: "auto",
                      }}
                    >
                      {accountColumn}を変更しない
                    </MenuItem>
                    <MenuItem
                      key={"follow_call_entry_status_conf"}
                      value={1}
                      sx={{
                        fontSize: "14px",
                        height: "24px",
                        minHeight: "auto",
                      }}
                    >
                      {accountColumn}を変更する
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box className="serch-label">{accountColumn}</Box>
              <Box key="hope_call_time">
                <FormControl
                  fullWidth
                  sx={{
                    marginTop: "10px",
                    marginBottom: "20px",
                    marginLeft: "5px",
                    width: "calc(100% - 10px)",
                  }}
                >
                  <Autocomplete
                    disabled={changeAccount === 0}
                    clearIcon={null}
                    options={autocompleteInputList}
                    value={autocompleteInput}
                    onChange={(event: any, newValue: string | null) => {
                      if (newValue) {
                        setAutocompleteInput(newValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        value={autocompleteInput}
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: "12px",
                            height: "32px", // ここでフォントサイズを指定
                          },
                        }}
                        {...params}
                      />
                    )}
                  />
                </FormControl>
              </Box>
            </Box>
          </Paper>
          <Box
            key="shozaiSelect"
            style={{ display: windowWidth > 385 ? "flex" : undefined }}
          >
            <Box
              style={{
                marginTop: "10px",
                height: "40px",
                width:
                  windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                marginLeft: windowWidth > 385 ? undefined : "5px",
              }}
            >
              <Button
                disabled={changeAccount === 1 && changeAccountID === null}
                variant="contained"
                style={{
                  height: "40px",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={() => getFormFunction()}
              >
                <Box className="m-plus-rounded-1c-regular">次へ</Box>
              </Button>
            </Box>
            <Box
              style={{
                marginTop: "10px",
                height: "40px",
                width:
                  windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                marginLeft: windowWidth > 385 ? "10px" : "5px",
              }}
            >
              <Button
                variant="contained"
                style={{
                  height: "40px",
                  width: "100%",
                  textTransform: "none",
                }}
                onClick={() => {
                  swCloseModal();
                }}
              >
                <Box className="m-plus-rounded-1c-regular">閉じる</Box>
              </Button>
            </Box>
          </Box>
        </Typography>
      </Box>
    </Modal>
  );
}
